"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSvg = void 0;
var fillXY_1 = require("../common/fillXY");
var BarChart_1 = require("./charts/BarChart");
var LineChart_1 = require("./charts/LineChart");
var StackbarChart_1 = require("./charts/StackbarChart");
var Chart = function (svg, config) {
    if (config.type === 'bar') {
        return BarChart_1.BarChart(svg, config);
    }
    if (config.type === 'line') {
        return LineChart_1.LineChart(svg, config);
    }
    return StackbarChart_1.StackbarChart(svg, config);
};
var createSvg = function (svg, groupConfig) {
    var chartCount = groupConfig.charts.length;
    var canvasWidth = Math.max.apply(Math, groupConfig.charts.map(function (it) { return it.width; })) + 2 * groupConfig.margin;
    var canvasHeight = groupConfig.charts.map(function (it) { return it.height - (it.offsetY ? it.offsetY : 0); }).reduce(function (acc, it) { return acc + it; }, 0) + (chartCount + 1) * groupConfig.margin;
    var viewbox = svg.viewbox(0, 0, canvasWidth, canvasHeight);
    viewbox.add(svg.rect('100%', '100%').fill('white'));
    var charts = fillXY_1.fillXY(groupConfig.charts, groupConfig.margin);
    var chartRefs = charts.map(function (it) {
        var child = Chart(svg, it);
        child.svg.x(it.x || 0)
            .y(it.y)
            .viewbox(0, 0, it.width, it.height);
        return child;
    });
    viewbox.getXYIndex = function (x, y) {
        return chartRefs[0].getXY(x, y);
    };
    return viewbox;
};
exports.createSvg = createSvg;
